import React, { PropsWithChildren, useCallback, useState } from 'react';

import { Button } from 'components/ui/Button';

import { ChevronSmall } from 'components/svg/ChevronSmall';

import { Fonts, spacing } from 'styles/theme';
import { Bumper, HorizontalFlexWrapper } from 'styles/shared';
import {
    BackgroundOverlay,
    ChevronWrapper,
    ContentExpander,
    ContentWrapper,
    SelectionWrapper,
    SelectionWrapperProps,
    TitleWrapper,
} from 'styles/selectableCard';

interface ExapandleCardProps extends PropsWithChildren, SelectionWrapperProps {
    title: string;
    subtitle?: string;
    onSelect: () => void;
    disabledText?: string;
    $isLoading: boolean;
}

export const SelectableCard = ({
    children,
    title,
    subtitle,
    onSelect,
    disabledText,
    $isLoading,
    $isSelected,
    $backgroundColor,
}: ExapandleCardProps) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const onPressChevron = useCallback(() => {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);

    return (
        <SelectionWrapper
            $isSelected={$isSelected}
            $backgroundColor={$backgroundColor}
        >
            <BackgroundOverlay />
            <ContentWrapper>
                <TitleWrapper>
                    <Fonts.Large $isOpenSansSemiBold>{title}</Fonts.Large>
                    <ChevronWrapper
                        onClick={onPressChevron}
                        $isExpanded={isExpanded}
                    >
                        <ChevronSmall width={18} height={18} />
                    </ChevronWrapper>
                </TitleWrapper>
                <Bumper $minHeight={spacing.xxxSmall} />
                {subtitle == null ? null : (
                    <>
                        <Fonts.Medium>{subtitle}</Fonts.Medium>
                        <Bumper />
                    </>
                )}
                {children == null ? null : (
                    <ContentExpander $isExpanded={isExpanded}>
                        {children}
                    </ContentExpander>
                )}
                <Bumper $minHeight={spacing.xxxSmall} />
                <HorizontalFlexWrapper $isContentSpread>
                    <div />
                    <Button
                        onClick={onSelect}
                        $isDisabled={disabledText != null}
                        $isLoading={$isLoading}
                        $style={
                            $isSelected || disabledText != null
                                ? 'fill'
                                : 'outline'
                        }
                    >
                        {disabledText != null
                            ? disabledText
                            : $isSelected
                            ? 'Selected'
                            : 'Select'}
                    </Button>
                </HorizontalFlexWrapper>
            </ContentWrapper>
        </SelectionWrapper>
    );
};
